
import React, { RefObject, useEffect, useRef } from 'react';
import Box from "@mui/material/Box";
import Popper from '@mui/material/Popper';
import { useLanguage } from '@/app/utils/LanguageContext';
import { textSize } from "@/app/utils/MixinSize";
import { useMyContext } from '@/app/utils/MyContext';

type propType = {
    isMobile: boolean;
    menuOption: Filter[];
    handleSelectOption: (selected: { [key: string]: string }, isTempFilter?: boolean) => void;
    addtionalOptionHandler?: (key: string, value: string) => void;
    addtionalClearHandler?: {
        [key: string]: () => void;
    }
    selectedOption: { [key: string]: string };
    anchorEl: RefObject<HTMLDivElement | null> | null;
    defaultOption: { [key: string]: string };
    altStyle?: boolean;
}

export type Option = {
    label: string;
    key: string | 'default';
}

export type Filter = {
    label: string;
    key: string;
    options: Option[];
}

export const generateFilter = (label: string, key: string, options: Option[], defaultLabel?: string) => {
    return {
        label: label,
        key: key,
        options: defaultLabel ? [{ label: defaultLabel, key: 'default' }].concat(options) : options,
    }
}

const PopUpFilter: React.FC<propType> = (props: propType) => {
    const { state:myContextState } = useMyContext();
    const { state: lang } = useLanguage();
    const { t } = lang;
    const [open, setOpen] = React.useState(Boolean(false));
    const [openSecond, setOpenSecond] = React.useState(false);
    const [currentMenu, setCurrentMenu] = React.useState<Option[]>([]);
    const [selected, setSelected] = React.useState<{ [key: string]: string }>(props.selectedOption);
    const [currentFilter, setCurrentFilter] = React.useState<Filter | null>(null);
    const [openSelectEvent, setOpenSelectEvent] = React.useState<any>(null);
    const id = open ? 'simple-Popper' : undefined;

    const { menuOption, anchorEl } = props;

    useEffect(() => {
        // set selected option to default when previous selected option non-exist
        let tobeSelected = {};
        menuOption.forEach((option) => {
            if (!option?.options?.find(o => o.key == selected[option.key]))
                tobeSelected = { [option.key]: "default" }
        })
        tobeSelected = { ...selected, ...tobeSelected }
        setSelected(tobeSelected)
    }, [props.menuOption])

    useEffect(() => {
        if (!props.isMobile) {
            handleClose();
        }
    }, [props.isMobile])

    const handleClose = () => {
        setOpen(false);
        setOpenSecond(false);
    };

    const openSecondFilter = (selectFilter: Filter) => {
        setOpen(false);
        setOpenSecond(true);
        setCurrentFilter(selectFilter);
        setCurrentMenu(menuOption.find(menu => menu.key == selectFilter.key)?.options || []);
    };

    const handBackPre = () => {
        setOpenSecond(false);
        setOpen(true);
    };

    const onClickResult = () => {
        setOpenSecond(false);
        setOpen(false);
        props.handleSelectOption(selected);
    };

    const onClickClear = () => {
        setSelected(props.defaultOption);
        if (props.addtionalClearHandler) {
            Object.keys(props.defaultOption)?.map((x: string) => {
                if (props.addtionalClearHandler?.[x])
                    props.addtionalClearHandler?.[x]();
            })
        }
    };

    const onClickFilter = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        if (!(open || openSecond)) {
            window.addEventListener("mousedown", handleOutSideClick);
            setOpen(true);
            setOpenSelectEvent(event.target)
        } else {
            handleClose();
        }
    };

    const handleOptionOnclick = (optionKey: string) => {
        if (props.addtionalOptionHandler)
            props.addtionalOptionHandler(currentFilter?.key || "", optionKey);
        setSelected({ ...selected, [currentFilter?.key || ""]: optionKey });
        setOpen(true);
        setOpenSecond(false);
        props.handleSelectOption({ ...selected, [currentFilter?.key || ""]: optionKey }, true);
    }

    const mainPopRef = useRef(null);
    const secondPopRef = useRef(null);
    const handleOutSideClick = (event: MouseEvent) => {
        event.stopPropagation();
        if (!(mainPopRef.current as any)?.contains(event.target) && !(secondPopRef.current as any)?.contains(event.target) && !(openSelectEvent?.contains(event.target))) {
            handleClose();
            window.removeEventListener("mousedown", handleOutSideClick);
        }
    };

    const getOptionLabel = (filterKey: string) => {
        return menuOption.find(i => i.key == filterKey)?.options?.find(opt => opt.key == selected[filterKey])?.label || "";
    }

    return (
        <>
            <img src={`${myContextState.assetPrefix}/fixture/mobilefilter${props.altStyle ? "_blue" : ""}.svg`}
                className="mobilefilterIcon"
                onClick={onClickFilter}>
            </img>
            <Popper
                ref={mainPopRef}
                id={id}
                open={open}
                anchorEl={anchorEl?.current}
                placement="bottom-end"
                className="popupFilter"
            >
                <Box sx={{ width: "240px", ...textSize(13), fontWeight: 500 }}>
                    <Box className="commHeaderTitle filterTitle" id="filterTitle">{t("filter")}</Box>
                    <Box className="mobile_filterPop">
                        {
                            menuOption.map((option) =>
                                <div key={`filter_${option.key}`} onClick={(e) => { openSecondFilter(option) }}>
                                    <p id={`filterLbl_${option.key}`}>{option.label}</p>
                                    <p id={`filterOpt_${option.key}`} className="filter_val" >{getOptionLabel(option.key)}</p>
                                </div>
                            )
                        }
                        <div className="filter_button">
                            <p id="filterClearBtn" onClick={onClickClear}>{t("filter_clear")}</p>
                            <p id="filterResultBtn" onClick={onClickResult}>{t("filter_confirm")}</p>
                        </div>
                    </Box>
                </Box>
            </Popper>

            <Popper
                ref={secondPopRef}
                id={id}
                open={openSecond}
                anchorEl={anchorEl?.current}
                placement="bottom-end"
            >
                <Box sx={{ width: "240px", ...textSize(13) }}>
                    <Box className="commHeaderTitle filterTitle" id="filterSecondTitle" sx={{ justifyContent: "start !important", paddingLeft: "0 !important" }}>
                        <img src={`${myContextState.assetPrefix}/fixture/arrowBack1.svg`} onClick={handBackPre} />
                        {currentFilter?.label}
                    </Box>
                    <Box className="mobile_filterPop secondFilter" >
                        {
                            currentMenu.map((item, idx) =>
                                <div key={`option_${item.key}`} id={`filterSecondLbl_${item.key}`} className={selected[currentFilter?.key || ""] == item.key ? "check" : ""} onClick={() => handleOptionOnclick(item.key)}>
                                    <p><img src={`${myContextState.assetPrefix}/fixture/check.svg`} /> </p> <p>{item.label} </p>
                                </div>
                            )
                        }
                    </Box>
                </Box>
            </Popper>
        </>
    )
}

export default PopUpFilter;